module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/event.json
// module id = 508
// module chunks = 0